import React from 'react';
import PropTypes from 'prop-types';
var sizeByDensity = {
  high: 3,
  medium: 5,
  low: 5,
  touch: 7
};

var ErrorIndicator = function ErrorIndicator(_ref) {
  var className = _ref.className,
      _ref$density = _ref.density,
      density = _ref$density === void 0 ? 'medium' : _ref$density;
  var size = sizeByDensity[density];
  var circleSize = size / 2;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    focusable: false,
    height: size,
    width: size
  }, /*#__PURE__*/React.createElement("circle", {
    cx: circleSize,
    cy: circleSize,
    r: circleSize
  }));
};

process.env.NODE_ENV !== "production" ? ErrorIndicator.propTypes = {
  className: PropTypes.string,
  density: PropTypes.oneOf(['touch', 'low', 'medium', 'high'])
} : void 0;
export default ErrorIndicator;